'use strict';

require('./UserAvatarService.js');

var DEFAULT_INITIALS = ["U"];

function firstChar(n) {
  return n.substr(0, 1);
}

function upperCase(c) {
  return c.toUpperCase();
}

function getParts(user) {
  if(typeof user.name === "string" && user.name.trim().length > 0) {
    return user.name.split(' ');
  }
  else if(typeof user.email === "string" && user.email.trim().length > 0) {
    return user.email.split(/[^a-z0-9_]/i);
  }
  else {
    return DEFAULT_INITIALS;
  }
}

function getInitials(user) {
  return getParts(user).map(firstChar).map(upperCase).join("").substr(0, 3);
}

function UserAvatarDirective(config) {
  return {
    restrict: 'A',
    replace:  true,
    template: '<div class="user-avatar"></div>',
    scope: {
      user: '=userAvatar'
    },
    link: function($scope, $elem) {
      var $initial = angular.element('<div class="user-avatar__initials">');
      var $text    = angular.element('<span>');

      $text.text(getInitials($scope.user));

      $initial.append($text);
      $elem.append($initial);

      function updateAvatar() {
        if( ! $scope.user.id) {
          return;
        }

        var $img = angular.element('<img />');

        $img.on("load", function() {
          $initial.remove();
          $elem.append($img);
        });

        $img.attr('src', config.apiBase + '/users/' + $scope.user.id + '/avatar');
      }

      $scope.$on('avatarChanged', updateAvatar);

      updateAvatar();
    }
  };
}

angular.module('dokiv')
  .directive('userAvatar', ['config', UserAvatarDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/user/UserAvatarDirective.js
// module id = 436
// module chunks = 0